import { Injectable } from '@angular/core';
import { Observable, of, delay } from 'rxjs';
import { VipPackage } from '../models/announcement.model';
import { MOCK_VIP_PACKAGES } from '../mocks/mock-vip-packages';

@Injectable({
  providedIn: 'root'
})
export class VipService {
  getVipPackages(): Observable<VipPackage[]> {
    return of(MOCK_VIP_PACKAGES).pipe(delay(300));
  }

  purchaseVipPackage(listingId: string, packageId: string, paymentData: any): Observable<boolean> {
    // Mock payment processing
    console.log(`Processing payment for listing ${listingId}, package ${packageId}`, paymentData);
    return of(true).pipe(delay(1500));
  }
}
